export const {
	useSelector
} = window.Megogo.interactive.hooks;
